import {useEffect, useState} from "react";
import {useWatch} from "react-hook-form";

const useWatchDropdown = ( { control,  name }) =>
{
    const [ value, setValue ] = useState ( null ) ;

    const meeting_location_type = useWatch({
        control: control,
        name: name,
    });

    useEffect(() => {
        if ( meeting_location_type === null || meeting_location_type === undefined )
        {
            setValue ( null ) ;
        }
        else
        {
            setValue( +(meeting_location_type.value) );
        }
    }, [ meeting_location_type ] ) ;

    return [ value ] ;
}

export default useWatchDropdown ;
